<template>
  <div class="bar_ret">
    <div class="ret" @click="back">
      <img
        v-if="isBridge"
        class="ret_img"
        :src="require('@/img/' + getTheme + '-back.png')"
        alt=""
      />
      <!-- <img class="ret_img"  src="@/img/back.png" alt="" />  -->
      <!-- <img
        class="ret_img"
        v-if="getTheme == 1"
        src="@/img/tag_tab_return.png"
      />
      <img class="ret_img" v-else src="@/img/back.png" alt="" /> -->
    </div>
    <div class="nav_text">{{ text }}</div>
  </div>
</template>
<script>
import configs from "@/config/config.js";
export default {
  props: ["text"],
  data() {
    return {
      getTheme: "",
      isBridge: false,
    };
  },
  created() {
    this.getTheme = configs.getTheme();
    if (window.TgaBridge) {
      this.isBridge = true;
    }
    if (window.Bridge) {
      this.isBridge = true;
    }
  },
  methods: {
    back() {
      const self = this;
      if (this.$route.path === "/index") {
        // 关闭页面
        if (window.TgaBridge) {
          TgaBridge.finishPage("close");
        } else if (window.Bridge) {
          window.Bridge.system.finishPage({});
        }
      } else {
        self.$router.go(-1);
      }
    },
  },
};
</script>
<style>
.bar_ret {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--navBackground);
  z-index: 1000;
}
@media screen and (min-width: 1000px) {
  .bar_ret {
    max-width: 800px !important;
    margin: 0 auto !important;
    left: auto;
  }
}
.ret {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  box-sizing: border-box;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0 0 0 0.51rem;
  display: flex;
  align-items: center;
}

.ret_img {
  width: 0.33rem;
  height: 0.54rem;
}
.nav_text {
  font-size: 0.54rem;
  color: var(--navColor);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/navBarIndex.vue